import React from 'react';

const Login = () => {
  const handleGoogleLogin = () => {
    // REDIRECT TO BACKEND GOOGLE AUTH
    window.location.href = 'https://api.freebidnow.com/api/auth/google';
  };

  return (
    <div className="flex flex-col md:flex-row h-screen">

      <div className="w-full md:w-1/2 bg-white p-8 md:p-12 flex flex-col justify-center">
        <img src="/images/freebidusa.png" alt="Logo" className="#" />
        <h1 className="text-4xl font-bold text-gray-800 mt-1 mb-4">
          Welcome Free Bid Now App
        </h1>
        <p className="text-lg text-gray-600 mb-6">
          Get real-time competitive bids on available loads.
        </p>
        <ul className="space-y-2 text-gray-700">
          <li>📍 View loads on an interactive map</li>
          <li>📬 Contact brokers via email instantly</li>
          <li>⏱️ Save time and win more bids</li>
        </ul>
      </div>

      <div className="w-full md:w-1/2 h-64 md:h-full relative">
        <video
          src="/videos/videotruck.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <button
            onClick={handleGoogleLogin}
            className="px-6 py-3 bg-yellow-500 text-green font-bold text-lg rounded hover:bg-yellow-400 transition"
          >
            Sign in with Google
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
